export interface GetChallengeInsightProgressSummaryResponseDto {
  value: number;
  average: number;
  endDateValue: number;
  formattedValue: string;
  formattedAverage: string;
  formattedEndDateValue: string;
  formattedDeviation: string; // deviation against challenge target (NOT FROM PERIOD)
  userCount: number;
  formattedSuccessPercentage: string;
  projectedSuccessForToday: boolean;
}
